import React from "react";
import { SchedulerViewComponentProps } from "../../types/views";
import ResourceTimeGridView from "../Calendar/ResourceTimeGridView";

/**
 * ResourceDayView
 *
 * Single-day scheduler view with resource columns. Thin wrapper around
 * ResourceTimeGridView so the registry contract stays consistent with
 * DayView and WeekView.
 */
const ResourceDayView: React.FC<SchedulerViewComponentProps> = (props) => {
  return <ResourceTimeGridView {...props} />;
};

export default ResourceDayView;
